function Home() {
  return (
    <div className="page">
      <h2>Home</h2>
      <p>Welcome to BrickWise. Start scanning your bricks to build your inventory.</p>
    </div>
  );
}

export default Home;
